import React, { useState } from 'react'

/**
 *
 */
const ReactiveSimulator = (props: Record<string, any>) => {
    const [value, setValue] = useState(props.initialValue)
    const onChange = (val) => {
        setValue(val)
        props.onChange && props.onChange(val)
    }
    return React.cloneElement(props.children, { value: value, onChange: onChange })
}

export default ReactiveSimulator
